const MissionDetailPage = () => {
	return (
		<div>
		</div>
	);
}

export default MissionDetailPage;